import React, { useContext, useEffect } from "react";
import { UserContext } from "./UserContext";
import { useNavigate } from "react-router-dom";

const withAuthorization = (WrappedComponent, allowedRoles) => {
  return (props) => {
    const { roleId } = useContext(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
      if (!allowedRoles.includes(roleId)) {
        navigate("/unauthorized");
      }
    }, [roleId, navigate]);

    if (!allowedRoles.includes(roleId)) {
      return null;
    }

    return <WrappedComponent {...props} />;
  };
};

export default withAuthorization;
